import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

import { doFetchPublicFeatures } from "../../../actions/feature";
import { doRequestLogout } from "../../../actions/session";
import { getChannel } from "../../../lib/utils";

const Login = () => {
  const dispatch = useDispatch();
  const channel = getChannel();

  useEffect(() => {
    dispatch(doRequestLogout());
    dispatch(doFetchPublicFeatures());
    dispatch(push(`../${sessionStorage.getItem("channelPath")}/landing`));
  }, [channel]);

  return <></>;
};

export default Login;
